<template>
  <div id="documents">
    <template v-if="Property">

      <div class="page-description" v-if="Property.files.length > 0">
        {{$t('documents.description')}}
      </div>

      <div class="files">
        <ExternalLink :url="getFile(file.url)" :target="target" class="file" v-for="file of Property.files">
          <div class="type">
            <svgicon :src="'svg/formats/' + getExtension(file.url) + '.svg'" :height="40" :width="40"></svgicon>
          </div>
          <div class="description">
            <div class="name" v-if="file.name">{{file.name}}</div>
            <div class="name" v-if="!file.name"><i>{{$t('documents.no_name')}}</i></div>
            <div class="date">{{file.createdAt}}</div>
          </div>
          <div class="actions">
            <svgicon class="icon download" src="svg/download.svg" :height="20" :width="20"/>
          </div>
        </ExternalLink>
        <div class="no-files" v-if="Property.files.length === 0">
          {{$t('documents.no_files')}}
        </div>
      </div>

    </template>
  </div>
</template>

<script>

  import Property from "../../core/Property";
  import ExternalLink from "../components/ExternalLink";

  export default {

    name: "Documents",

    data() {
      return {
        Property
      }
    },

    components: { ExternalLink },

    async mounted() {
      this.$store.commit("setDisplay", {
        showHeader: true,
        showHeaderLeft: true,
        showFooter: true,
        headerTitle: "menu.documents",
        headerIcon: "/svg/folder.svg"
      });

      showSpinner();
      await Property.init();
      await Property.loadFiles();
      hideSpinner();

      setTimeout(() => this.$forceUpdate(), 0);
    },

    computed: {
      target() {
        if (typeof cordova != "undefined" && typeof device != "undefined"  && device.platform == "Android") {
          return "_system";
        } else {
          return "_blank";
        }
      }
    },

    methods: {
      getFile(url) {
        return CONFIG.urlFiles + url;
      },
      getExtension(url) {
        return url.split(".")[1].toLowerCase();
      }
    }
  }
</script>

<style lang="scss" scoped>
  #documents {
    display: flex;
    flex-direction: column;
    background-color: #f2f3f4;
    padding: 20px;
  }

  .files {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    justify-content: center;
    overflow-y: auto;
    margin: 0 -10px;
  }

  .file {
    background-color: white;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
    width: 100%;
    max-width: 480px;
    display: flex;
    text-decoration: none;
    cursor: pointer;
    margin: 10px;

    &:hover:not(.btn) {
      text-decoration: none;
    }

    .type {
      min-height: 80px;
      width: 80px;
      flex-shrink: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: #dfe2e3;
      fill: #9CA5A9;
    }

    .description {
      display: flex;
      flex-grow: 1;
      flex-direction: column;
      justify-content: center;
      padding: 20px;

      .name {
        font-size: 20px;
        font-weight: 500;
        margin-bottom: 8px;
      }

      .date {
        color: #808b91;
      }
    }
    .actions {
      padding: 20px 20px 20px 0;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;

      .icon {
        cursor: pointer;
        fill: #bfc5c8;
      }
    }
  }

  .no-files {
    text-align: center;
    opacity: 0.6;
  }

  .page-description {
    text-align: center;
    padding-bottom: 20px;
  }

  @media (max-width: 1200px) {
    .files {
      justify-content: center;
    }
  }

  @media screen and (max-width: 720px) {
    .file {
      .type {
        width: 60px;
        min-height: 60px;
      }
      .description {
        font-size: 14px;

        .name {
          font-size: 17px;
          margin-bottom: 5px;
        }
      }
    }
  }
</style>
